import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {ParcelsService} from '../../../services/parcels.service';
import {Parcel, Resident, ResidentForSelect} from '../../../types/models';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AccountPermissionsService} from '../../../services/account-permissions.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'parcel-mass-modal',
    templateUrl: './parcel-mass-modal.component.html',
    styleUrls: ['./parcel-mass-modal.component.scss']
})
export class ParcelMassModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: Array<Parcel> = [];
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    time = ParcelMassModalComponent.parseTime((new Date()).toISOString());
    buildingId: number;
    parcelPostServiceId: number;
    otherCourierNameModel: string;
    inOut = 'Incoming';
    allChecked = false;
    useParcelsWaiver = false;
    selectedBuildingCorporation = null;

    public includeAllUnits: boolean = false;

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public parcelsService: ParcelsService,
        public urlService: UrlService,
        public accountService: AccountPermissionsService
    ) {
    }

    ngOnInit() {
        this.initData();
        this.initTimePicker();
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initTimePicker() {
        $('#timepicker1').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
    }

    openTimepicker(): void {
        $('#timepicker1').timepicker('showWidget');
    }

    initData() {
        const b = this.urlService.queryParams['building'];
        if (b) {
            this.buildingId = b;
            this.changeBuilding(b);
            this.getSuites(+this.buildingId);
        }

        if (this.parcelsService.buildingsForUpdate.length === 1) {
            this.buildingId = this.parcelsService.buildingsForUpdate[0].id;
            this.changeBuilding(this.parcelsService.buildingsForUpdate[0].id.toString());
        }

        for (let i = 0; i < 3; i++) {
            this.addParcel();
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.parcelsService.isMassParcelModalShow = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.parcelsService.isMassParcelModalShow = false;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.buildingId) toastr.warning('Building should not be blank.');
            return;
        }
        const filledRows = this.data.filter(i => {
            return i.suiteId || (i.suiteId === 0 && i.suiteNumber) ||
                (i.residentId && (<any>i.residentId) !== '0') || ((<any>i.residentId) === '0' && !i.residentFullName);
        });
        if (filledRows.length < 1) {
            toastr.warning('At least one line must be filled.');
            return;
        }
        for (const filledRow of filledRows) {
            if (filledRow.suiteId === null || (filledRow.suiteId === 0 && !filledRow.suiteNumber) ||
                filledRow.residentId === null || (<any>filledRow.residentId) === '' ||
                ((<any>filledRow.residentId) === '0' && !filledRow.residentFullName)) {
                toastr.warning('Each line must have unit and resident information.');
                return;
            }
            if (filledRow.numberPieces && filledRow.numberPieces < 1) {
                toastr.warning('Each line must have number of pieces more than 0');
                return;
            }
        }
        const building = this.parcelsService.buildings.find((item) => item.id == form.value.buildingId);

        const dataArray = [];
        filledRows.forEach((value, index) => {
            const suite = this.suites.find((item) => item.id == value.suiteId);
            const resident = (<any>value).residents.find((item) => item.id == value.residentId);
            if (!suite) {
                toastr.warning('Suite not found.');
                return;
            }
            if (!resident) {
                toastr.warning('Resident not found.');
                return;
            }
            const data: any = {
                building: {
                    bdId: building ? +building.id : null,
                    name: building ? building.name : null,
                    address: building ? building.address : null,
                    timezone: building ? (building.timeZone ? building.timeZone.value : null) : null,
                    corporationNumberBd: building ? building.corporationNumber : null
                },
                suite: {
                    bdId: suite.id ? +suite.id : undefined,
                    suiteNumber: suite.id ? suite.name : filledRows[index].suiteNumber,
                },
                resident: {
                    bdId: resident.id ? +resident.id : undefined,
                    fullName: resident.id ? resident.fullName : filledRows[index].residentFullName,
                    mobilePhone: this.getMobilePhone(resident)
                },
                parcelPostService: form.value.parcelPostServiceId == -1 ? null : form.value.parcelPostServiceId,
                numberPieces: value.numberPieces,
                barCode: value.barCode,
                parcelType: value.parcelTypeId,
                inOut: this.inOut,
                description: value.description,
                createdAt: this.getDateTimeFromForm(),
                emailNotice: +value.emailNotice,
                // smsNotice:
            };
            if (form.value.parcelPostServiceId == -1) {
                data.parcelPostServiceName = this.otherCourierNameModel;
            }

            if (resident && resident.email) data.resident.email = resident.email;
            if (resident && this.getResidentPhone(resident)) data.resident.phone = this.getResidentPhone(resident);
            dataArray.push(data);
        });
        let residentWithWaiverUnsignedPresent = false;
        filledRows.forEach(item => {
            const resident = (<any>item).residents.find((res) => res.id == item.residentId);
            if (!resident.parcelWaiverSigned && resident.id != 0)
                residentWithWaiverUnsignedPresent = true;
        });
        if (!residentWithWaiverUnsignedPresent) {
            this.disabledSubmit = true;

            this.api.post('domainParcels', '/v1/multi-parcels.json', {parcels: dataArray}).subscribe(
                () => this.updateView('Parcels successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create parcels failed');
                }
            );
        } else {
            swal(ConstantsService.getSwalConfig('Are you sure?', 'You are about to receive a package on behalf of a resident who has not signed a waiver, would you like to continue?'),
                () => {
                    this.disabledSubmit = true;

                    this.api.post('domainParcels', '/v1/multi-parcels.json', {parcels: dataArray}).subscribe(
                        () => this.updateView('Parcels successfully created'),
                        error => {
                            this.disabledSubmit = false;
                            this.api.errorHandler(error, 'Create parcels failed');
                        }
                    );
                }
            );
        }
    }

    getDateTimeFromForm(): Date {
        const date = new Date(this.form.value.date);
        const time = this.form.value.time;
        const timeObj = new Date(`01 01 1970 ${time}`);
        const hours = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return date;
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.parcelsService.getData();
        this.form.reset();
        this.hideModal();
    }

    changeBuilding(buildingId: string) {
        this.getSuites(+buildingId);
        const building = this.parcelsService.buildings.find(b => b.id == buildingId);
        this.getCorporationSettings(building.corporationNumber);
        this.selectedBuildingCorporation = building.corporationNumber;

        // const selectedCorporationTypes = this.getParcelTypesForSelectedCorporation();
        // const boxTypeIndex = selectedCorporationTypes.findIndex(t => t.name.toLowerCase() == 'box');
        // this.data.forEach(item => {
        //     item.suiteId = null;
        //     item.residentId = null;
        //     (<any>item).residents = [];
        //     item.emailNotice = false;
        //     if(boxTypeIndex != -1)
        //         item.parcelTypeId = selectedCorporationTypes[boxTypeIndex].id;
        // });
    }

    changeUnit(suiteId: string, parcel: Parcel, index: number) {
        parcel.residentId = undefined;
        this.getResidents(+suiteId, parcel);
        if (suiteId + '' === '0') {
            parcel.residentId = 0;
            parcel.suiteNumber = '';
            parcel.residentFullName = '';
            parcel.residents.push(new ResidentForSelect(0, 'Other'));
        }
        parcel.emailNotice = false;
        if (index === this.data.length - 1 && suiteId) {
            this.addParcel();
        }
    }

    changeResident(residentId, parcel) {
        if (residentId === 0) {
            parcel.residentFullName = '';
            parcel.emailNotice = false;
        } else {
            parcel.emailNotice = !!this.residentHasEmail(parcel);
        }
        this.setAllEmailsCheckedCheckbox();
    }

    getSuites(buildingId: number): void {
        if (!buildingId) return;
        this.suites = [];
        this.residents = [];
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
            },
            error => this.api.errorHandler(error, 'Failed get suites')
        );
    }

    getResidents(suiteId: number, parcel: Parcel): void {
        parcel.residents = [];
        if (!suiteId) return;
        const url = `/v1/residents.json?per-page=1000&suite_id=${suiteId}&expand=suiteUser`;
        this.api.getJson('domainBD', url).subscribe(
            res => {
                const residents = res.entities;
                parcel.residents = residents.map(item => {
                    const residentForSelect = new ResidentForSelect(item.id, item.fullName, item.suiteUser, item.email);
                    residentForSelect['parcelWaiverSigned'] = item.parcelWaiverSigned;
                    if (item.phones && item.phones.length > 0) {
                        residentForSelect['phones'] = item.phones;
                    }
                    return residentForSelect;
                });
                parcel.residents.push(new ResidentForSelect(0, 'Other'));
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    addParcel() {
        const parcel = new Parcel();

        // const selectedCorporationTypes = this.buildingId ? this.getParcelTypesForSelectedCorporation() : [];
        // const boxTypeIndex = selectedCorporationTypes.findIndex(t => t.name.toLowerCase() == 'box');
        // if(boxTypeIndex != -1)
        //     parcel.parcelTypeId = selectedCorporationTypes[boxTypeIndex].id;
        //
        // parcel.numberPieces = 1;

        this.data.push(parcel);
        this.allChecked = false;
    }

    allCheckedChange() {
        this.data.forEach((parcel, index) => {
            if (document.getElementById('emailNotice' + index))
                parcel.emailNotice = this.allChecked;
        });
    }

    noticeCheckboxChange(event) {
        if (!event.target.checked)
            this.allChecked = false;
        else
            this.setAllEmailsCheckedCheckbox();
    }

    deleteRow(index) {
        this.data.splice(index, 1);
    }

    clickSubmit() {
        $('#formSubmit').click();
    }

    residentHasEmail(rowData) {
        if (!rowData.residents || rowData.residents.length === 0 || !rowData.residentId)
            return '';
        const resident = rowData.residents.find((item) => item.id == rowData.residentId);
        return resident.email;
    }

    residentHasPhone(rowData) {
        if (!rowData.residents || rowData.residents.length === 0 || !rowData.residentId)
            return '';
        const resident = rowData.residents.find((item) => item.id == rowData.residentId);
        if (!resident.phones)
            return '';
        let primaryPhone = resident.phones.filter(phone => phone.isPrimaryPhone)[0];
        if (!primaryPhone || primaryPhone.length === 0)
            primaryPhone = resident.phones[0];
        return primaryPhone ? primaryPhone.phone : '';
    }

    getResidentPhone(resident) {
        if (!resident.phones || resident.phones.length < 1)
            return '';
        let primaryPhone = resident.phones.filter(phone => phone.isPrimaryPhone)[0];
        if (!primaryPhone || primaryPhone.length === 0)
            primaryPhone = resident.phones[0];
        return primaryPhone.phone;
    }

    getMobilePhone(resident) {
        if (!resident)
            return undefined;
        if (!resident.phones || resident.phones.length < 1)
            return undefined;
        const mobilePhones = resident.phones.filter(p => p.phoneType == 'phone_cell' && p.realPhoneType == 'phone_cell');
        if (!mobilePhones || mobilePhones.length === 0)
            return undefined;
        return mobilePhones[0].phone;
    }

    loadAllUnits() {
        this.changeBuilding(this.form.value.buildingId);
    }

    /**
     * Adds email to the profile
     * for selected resident
     *
     * @param el
     * @param item
     */
    public setResidentEmail(el: HTMLInputElement & { spinnerShow: boolean }, item: Parcel & { residents: ResidentForSelect[] }): void {
        if (!el.value || !el.validity.valid) {
            toastr.error('Invalid Email');

            return;
        }

        const resident = item.residents.find((resident) => +resident.id === +item.residentId);
        const suiteUser = resident.suiteUsers.find(suiteUser => +suiteUser.suite === +item.suiteId);

        el.spinnerShow = true;
        this.parcelsService.setResidentEmail(suiteUser.id, el.value)
            .finally(() => el.spinnerShow = false)
            .subscribe(
                (result: Resident) => {
                    resident.email = result.email;
                    item.emailNotice = true;
                    el.spinnerShow = false;
                }
            );
    }

    atLeastOneResidentHasEmail(): boolean {
        return this.data.filter(item => this.residentHasEmail(item)).length > 0;
    }

    setAllEmailsCheckedCheckbox(): void {
        let allChecked = true;
        this.data.forEach(parcel => {
            const resident = ((<any>parcel).residents || []).find((item) => item.id == parcel.residentId);
            if (resident && resident.email && !parcel.emailNotice)
                allChecked = parcel.emailNotice;
        });
        this.allChecked = allChecked;
    }

    getCorporationSettings(id) {
        const url = `/v1/corporation_number/${id}.json?expand=settings`;
        this.api.get('domainBD', url).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                this.useParcelsWaiver = body.settings ? body.settings.useParcelsWaiver : false;
            },
            error => this.api.errorHandler(error, 'Failed get Services')
        );
    }

    residentsToSearchSelect(arr: Array<any>) {
        if (!arr)
            return [];

        return arr.map(resident => ({
            ...resident,
            value: resident.id,
            optionText: resident.fullName
        }));
    }

    getParcelTypesForSelectedCorporation() {
        return this.parcelsService.parcelTypes.filter(
            t => t.parcelServiceSettings == this.selectedBuildingCorporation
        );
    }

    canEditDirectory() {
        return this.accountService.canUpdate('bldn', this.form.value.buildingId);
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-mass-modal/parcel-mass-modal.component.ts